import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { Empty } from '../components/ui/States';

import type { NavItem } from '../layout/nav';

/** "martes 27 de octubre" en el idioma de la interfaz y la zona de la clínica (docs/08 §11). */
export function longDate(date: Date, language: string, timeZone = 'America/Asuncion'): string {
  // Sin la coma que agrega Intl después del día de la semana (como el prototipo).
  const weekday = new Intl.DateTimeFormat(language, { weekday: 'long', timeZone }).format(date);
  const dayMonth = new Intl.DateTimeFormat(language, { day: 'numeric', month: 'long', timeZone }).format(
    date,
  );
  return `${weekday} ${dayMonth}`;
}

/** Secciones del rail que todavía no tienen pantalla: título y estado vacío. */
export function SectionPage({ section }: { section: NavItem['key'] | 'profile' }) {
  const { t } = useTranslation();
  return (
    <>
      <h1>{section === 'profile' ? t('topbar.profile') : t(`nav.${section}`)}</h1>
      <section className="card">
        <Empty title={t('common.sectionComingSoon')} />
      </section>
    </>
  );
}

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <main className="auth-page">
      <div className="card auth-card">
        <Empty
          icon="search"
          title={t('common.notFound')}
          action={
            <Link className="btn" to="/my-day">
              {t('common.goHome')}
            </Link>
          }
        />
      </div>
    </main>
  );
}
